export default __webpack_public_path__ + "static/media/2033.9011cee7.png";